import { FC, memo } from 'react';
import { shallowEqual } from 'react-redux';
import { LocalVideo, RemoteParticipant } from '@/components';
import { selectRoomPinned, selectRoomPinnedSize } from '@/store/features/room/selectors';
import { ParticipantSid } from '@/store/features/room/types';
import { useAppSelector } from '@/store/hooks';
import { StyledVideoTile } from './styled';

type Props = {
  sid: ParticipantSid;
  totalParticipants: number;
  isAbsolute?: boolean;
  hasPinned?: boolean;
};

const VideoTile: FC<Props> = ({
  sid,
  totalParticipants,
  isAbsolute,
  hasPinned,
}) => {
  const pinned = useAppSelector(selectRoomPinned);
  const sizes = useAppSelector(
    selectRoomPinnedSize(sid),
    shallowEqual,
  );

  return (
    <StyledVideoTile
      $absolute={isAbsolute}
      $isPinned={pinned === sid}
      $hasPinned={hasPinned}
      $total={totalParticipants}
      $pinnedWidth={sizes?.width}
      $pinnedHeight={sizes?.height}
    >
      {sid === 'local' ? <LocalVideo absolute={isAbsolute} /> : <RemoteParticipant key={sid} sid={sid} />}
    </StyledVideoTile>
  );
};

export default memo(VideoTile);